import { createAction, props } from '@ngrx/store';

export const setData = createAction('[Availability Rules] Set Availability Rules Data', props<{ data: object }>());
